import React, { useState, useEffect } from "react";
import "../App.css";
import HeroSection from "../components/HeroSection";
import Footer from "../components/Footer";
import CenterMedia from "../components/CenterMedia";
import FullWidthMedia from "../components/FullWidthMedia";
import TwoColumnMedia from "../components/TwoColumnMedia";
import ThreeColumns from "../components/ThreeColumns";
import Gap from "../components/Gap";
import LazyLoad from "react-lazy-load";
import GridMediaLayout from "../components/GridMediaLayout";
import ResponsiveImageCarousel from "../components/ResponsiveImageCarousel";


function Home() {
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  const ar_by_rhea_image_carousel_images = [
    { src: "../Home/a&r-by-rhea/IMG_6580.webp", alt: "Image 6580" },
    { src: "../Home/a&r-by-rhea/IMG_6577.webp", alt: "Image 6577" },
    { src: "../Home/a&r-by-rhea/IMG_6581.webp", alt: "Image 6581" },
    { src: "../Home/a&r-by-rhea/IMG_6591.webp", alt: "Image 6591" },
    { src: "../Home/a&r-by-rhea/IMG_6602.webp", alt: "Image 6602" },
    { src: "../Home/a&r-by-rhea/IMG_6603.webp", alt: "Image 6603" },
    { src: "../Home/a&r-by-rhea/IMG_6604.webp", alt: "Image 6604" },
    { src: "../Home/a&r-by-rhea/IMG_6607.webp", alt: "Image 6607" },
    { src: "../Home/a&r-by-rhea/IMG_6609.webp", alt: "Image 6609" },
    { src: "../Home/a&r-by-rhea/IMG_6613.webp", alt: "Image 6613" },
    { src: "../Home/a&r-by-rhea/IMG_6615.webp", alt: "Image 6615" },
    { src: "../Home/a&r-by-rhea/IMG_6617.webp", alt: "Image 6617" },
    { src: "../Home/a&r-by-rhea/IMG_6622.webp", alt: "Image 6622" },
    { src: "../Home/a&r-by-rhea/IMG_6623.webp", alt: "Image 6623" },
    { src: "../Home/a&r-by-rhea/IMG_6580.webp", alt: "Image 6580" },
    { src: "../Home/a&r-by-rhea/IMG_6577.webp", alt: "Image 6577" },
    { src: "../Home/a&r-by-rhea/IMG_6581.webp", alt: "Image 6581" },
    { src: "../Home/a&r-by-rhea/IMG_6591.webp", alt: "Image 6591" },
    { src: "../Home/a&r-by-rhea/IMG_6602.webp", alt: "Image 6602" },
    { src: "../Home/a&r-by-rhea/IMG_6603.webp", alt: "Image 6603" },
    { src: "../Home/a&r-by-rhea/IMG_6604.webp", alt: "Image 6604" },
    { src: "../Home/a&r-by-rhea/IMG_6607.webp", alt: "Image 6607" },
    { src: "../Home/a&r-by-rhea/IMG_6609.webp", alt: "Image 6609" },
    { src: "../Home/a&r-by-rhea/IMG_6613.webp", alt: "Image 6613" },
    { src: "../Home/a&r-by-rhea/IMG_6615.webp", alt: "Image 6615" },
    { src: "../Home/a&r-by-rhea/IMG_6617.webp", alt: "Image 6617" },
    { src: "../Home/a&r-by-rhea/IMG_6622.webp", alt: "Image 6622" },
    { src: "../Home/a&r-by-rhea/IMG_6623.webp", alt: "Image 6623" },
    { src: "../Home/a&r-by-rhea/IMG_6580.webp", alt: "Image 6580" },
    { src: "../Home/a&r-by-rhea/IMG_6577.webp", alt: "Image 6577" },
    { src: "../Home/a&r-by-rhea/IMG_6581.webp", alt: "Image 6581" },
    { src: "../Home/a&r-by-rhea/IMG_6591.webp", alt: "Image 6591" },
    { src: "../Home/a&r-by-rhea/IMG_6602.webp", alt: "Image 6602" },
    { src: "../Home/a&r-by-rhea/IMG_6603.webp", alt: "Image 6603" },
    { src: "../Home/a&r-by-rhea/IMG_6604.webp", alt: "Image 6604" },
    { src: "../Home/a&r-by-rhea/IMG_6607.webp", alt: "Image 6607" },
    { src: "../Home/a&r-by-rhea/IMG_6609.webp", alt: "Image 6609" },
    { src: "../Home/a&r-by-rhea/IMG_6613.webp", alt: "Image 6613" },
    { src: "../Home/a&r-by-rhea/IMG_6615.webp", alt: "Image 6615" },
    { src: "../Home/a&r-by-rhea/IMG_6617.webp", alt: "Image 6617" },
    { src: "../Home/a&r-by-rhea/IMG_6622.webp", alt: "Image 6622" },
    { src: "../Home/a&r-by-rhea/IMG_6623.webp", alt: "Image 6623" },
    { src: "../Home/a&r-by-rhea/IMG_6580.webp", alt: "Image 6580" },
    { src: "../Home/a&r-by-rhea/IMG_6577.webp", alt: "Image 6577" },
    { src: "../Home/a&r-by-rhea/IMG_6581.webp", alt: "Image 6581" },
    { src: "../Home/a&r-by-rhea/IMG_6591.webp", alt: "Image 6591" },
    { src: "../Home/a&r-by-rhea/IMG_6602.webp", alt: "Image 6602" },
    { src: "../Home/a&r-by-rhea/IMG_6603.webp", alt: "Image 6603" },
    { src: "../Home/a&r-by-rhea/IMG_6604.webp", alt: "Image 6604" },
    { src: "../Home/a&r-by-rhea/IMG_6607.webp", alt: "Image 6607" },
    { src: "../Home/a&r-by-rhea/IMG_6609.webp", alt: "Image 6609" },
    { src: "../Home/a&r-by-rhea/IMG_6613.webp", alt: "Image 6613" },
    { src: "../Home/a&r-by-rhea/IMG_6615.webp", alt: "Image 6615" },
    { src: "../Home/a&r-by-rhea/IMG_6617.webp", alt: "Image 6617" },
    { src: "../Home/a&r-by-rhea/IMG_6622.webp", alt: "Image 6622" },
    { src: "../Home/a&r-by-rhea/IMG_6623.webp", alt: "Image 6623" },
  ];

  const marie_clarie_images = [
    {
      type: "image",
      src: "../Home/marie clarie/2.webp",
      alt: "Marie Clarie Image 2",
      row: 1,
      column: 3,
    },
    {
      type: "image",
      src: "../Home/marie clarie/1.webp",
      alt: "Marie Clarie Image 1",
      row: 1,
      column: 1,
    },
    {
      type: "image",
      src: "../Home/marie clarie/3.webp",
      alt: "Marie Clarie Image 3",
      row: 1,
      column: 2,
    },
  ];

  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("scroll", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("scroll", handleUserInteraction);
    };
  }, []);

  return (
    <>
      <HeroSection
        media={{ src: "../Home/Esha-dii/elle no border.mp4", type: "video" }}
      />

      <Gap />

      <div class="container">
        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{ src: "../Home/eden/eden.mp4", type: "video" }}
            column="center"
            responsivePadding={true}
            maxPadding={500}
            disablePaddingOnMobile={true}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap size={10} />

        {/* <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../logos-and-png-text/mero.webp",
              type: "image",
            }}
            paddingLeft={900}
            paddingRight={900}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/mero.webp"
              alt="Unique Overlay Logo"
              className="unique-logo-image"
            />
          </LazyLoad>
        </div>

        {/* <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/mero.webp",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={900}
            disablePaddingOnMobile={false}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Home/jl/DSCF8531.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <GridMediaLayout
          mediaItems={marie_clarie_images}
          rows={1}
          columns={3}
          paddingLeft={0}
          paddingRight={0}
        />

        {/* <LazyLoad  preload offset={300} once>
          <div class="padding-0">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                { type: "image", src: "../Home/marie clarie/2.webp" },
                {
                  type: "image",
                  src: "../Home/marie clarie/1.webp",
                },
                {
                  type: "image",
                  src: "../Home/marie clarie/3.webp",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Home/uk-snippets-travel/tdp-2.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={ar_by_rhea_image_carousel_images}
            timer={3000}
            imageHeight={600}
            gap={0}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              { type: "video", src: "../Home/amama/Gul-2.mp4" },
              {
                type: "video",
                src: "../Home/amama/Gul-4.mp4",
              },
              { type: "video", src: "../Home/amama/Gul-5.mp4" },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        {/* <Gap />

        <LazyLoad  preload offset={300} once>
          <ThreeColumns
            layout="first-two-spanned"
            mediaList={[
              {
                type: "video",
                src: "../Home/boult/boult-post.mp4",
                width: "300%",
                height: "auto",
                position: "center", // Horizontal alignment
                verticalAlign: "center", // Vertical alignment
                column: "left",
              },
              { type: "video", src: "../Home/boult/boult-xr.mp4" },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <div class="trisara-section">
            <TwoColumnMedia
              media={[
                { type: "video", src: "../Home/trisara/trisaraaaaaaaaaa.mp4" },
                {
                  type: "image",
                  src: "../logos-and-png-text/summersorbet.webp",
                  width: "350px",
                  height: "350px",
                  verticalAlign: "center",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>

        {/* <Gap />

        <LazyLoad  preload offset={300} once>
          <FullWidthMedia
            media={{
              src: "../Home/a&r-by-rhea/velvets-onli.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../Home/gaurav-gupta/gg-the-great.mp4",
              type: "video",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={500}
            disablePaddingOnMobile={true}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        {/* CHANGE THIS   */}
        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/mulmul/C0609.MOV",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/Mulmul-_Hindi_logo_1200_x_628_px.webp"
              alt="Unique Overlay Logo"
              className="unique-logo-image"
            />
          </LazyLoad>
        </div>

        {/* <LazyLoad preload offset={1000}>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/Mulmul-_Hindi_logo_1200_x_628_px.webp",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={850}
            disablePaddingOnMobile={false}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap size={70} />

        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../Home/house-of-alams/screen/ZODIAC-LANDSCAPE-EDITED.mov",
              type: "video",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={300}
            disablePaddingOnMobile={true}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap size={10} />

        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/final-logo.webp"
              alt="Unique Overlay Logo"
              className="unique-logo-image-home"
            />
          </LazyLoad>
        </div>

        {/* <LazyLoad preload offset={1000}>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/final-logo.webp",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={700}
            disablePaddingOnMobile={false}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        {/* <LazyLoad  preload offset={300} once>
          <ThreeColumns
            layout="last-two-spanned"
            mediaList={[
              {
                type: "image",
                src: "../logos-and-png-text/final-logo.webp",
                width: "70%",
                height: "auto",
                position: "center",
                verticalAlign: "center",
              },
              {
                type: "video",
                src: "../Home/house-of-alams/screen/ZODIAC-LANDSCAPE-EDITED.mov",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        {/* <Gap size={0} /> */}

        {/* <LazyLoad  preload offset={300} once>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/mero.webp",
              type: "image",
            }}
            column="center"
            size="smallImg"
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />
        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "image",
                src: "../Home/stills/post.webp",
                column: "center", // Place this image in the center column
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>
      </div>
      <Footer />
    </>
  );
}

export default Home;
